import environmentConfig from './environment.json';

// Map Vite mode to environment config keys
// Vite uses: localhost (dev server), development, test, production (builds)
// Config uses: local, development, test, production
const modeToEnv: Record<string, string> = {
  'localhost': 'local',
  'development': 'development',
  'test': 'test',
  'production': 'production',
};

const viteMode = import.meta.env.MODE;
export const environment = modeToEnv[viteMode] || viteMode || process.env.NODE_ENV;

if (!environment) {
  throw new Error('environment is not set!');
}

const get = (configSelector: (cfg) => object): string => {
  const config = configSelector(environmentConfig);
  // Use ?? instead of || to allow empty strings (for relative API URLs)
  return config[environment] ?? config['shared'];
};

export const apiUrl = get(cfg => cfg.apiUrl);
export const adal = {
  instance: get(cfg => cfg.adal.instance),
  tenant: get(cfg => cfg.adal.tenant),
  clientId: get(cfg => cfg.adal.clientId),
  postLogoutRedirectUri: get(cfg => cfg.adal.postLogoutRedirectUri),
  cacheLocation: get(cfg => cfg.adal.cacheLocation),
  serviceClientId: get(cfg => cfg.adal.serviceClientId),
  serviceUrl: get(cfg => cfg.adal.instance),
  scopes: get(cfg => cfg.adal.scopes)
};
